<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Depot
      </p>
    </header>

    <section class="modal-card-body">
      <a-card
        :editable="false"
      >
        <a-input
          :field="`depots.${id}.name`"
          :label="$t('common.name')"
        />

        <a-input
          :field="`depots.${id}.address`"
          :label="$t('common.address')"
        />

        <a-input
          :field="`depots.${id}.city`"
          :label="$t('common.city')"
        />

        <a-input
          :field="`depots.${id}.zip`"
          :label="$t('common.zip')"
        />

        <a-autocomplete
          :field="`depots.${id}.country`"
          :label="$t('common.country')"
          field="country"
          :options="countries"
          option-label="country"
        />
      </a-card>
    </section>
    <footer class="modal-card-foot">
      <b-button
        type="is-danger"
        icon-left="delete"
        @click="remove"
      >
        {{ $t('common.delete') }}
      </b-button>
      <button
        class="button is-success"
        type="button"
        @click="close"
      >
        <span>
          {{ $t('common.ok') }}
        </span>
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    id: {
      required: true
    }
  },
  computed: {
    countries () {
      return _.sortBy(_.uniqBy(this.$store.getters['operators/items'], 'country'), 'country')
    }
  },
  methods: {
    close () {
      this.$parent.close()
    },
    remove () {
      this.$store.dispatch('operators/delete', `${this.doc.id}.depots.${this.id}`)
      this.close()
    }
  }
}
</script>

<style scoped>
.modal-card {
    width: auto;
}
.modal-card-body {
    width: auto;
}
</style>
